module.exports = __webpack_public_path__ + "img/Zugführer_Betreuungszug.d0403940.svg";